import { toTypedSchema } from '@vee-validate/zod'
import { object, string } from 'zod'

export const contactSchema = toTypedSchema(
  object({
    subject: string().min(1, { message: 'common.validation.mandatory' }),
    message: string().min(1, { message: 'common.validation.mandatory' }),
  })
)
